import React from "react";
import UI from "@components/Home/Favourites/Tile/UI";
import { Album as AlbumType } from "@libs/wire";

const Album = ({ album }: { album: AlbumType }) => {
  return (
    <UI
      title={album.title}
      images={album.image}
      href={{
        pathname: "/(app)/(tabs)/explore/[collectionType]/[collectionId]",
        params: {
          collectionType: "album",
          collectionId: album.id,
        },
      }}
    />
  );
};

export default Album;
